import { render, staticRenderFns } from "./message-panel.vue?vue&type=template&id=1fecd738&scoped=true"
import script from "./message-panel.vue?vue&type=script&lang=ts"
export * from "./message-panel.vue?vue&type=script&lang=ts"
import style0 from "./message-panel.vue?vue&type=style&index=0&id=1fecd738&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fecd738",
  null
  
)

export default component.exports